module.exports = __webpack_public_path__ + "img/italy-digestive-diseases-female.0169ae13.png";